import React from 'react'
import TextBox from '../../../../../../../common/components/molecule/TextBox/TextBox'

export interface ZhagaNodeViewProps {
    devui?: string 
}

export default function ZhagaNodeView({devui}: ZhagaNodeViewProps) {
  return (
    <TextBox variant='dark' content={[{
        title: 'Noeud Zhaga Devui',
        text: devui
    }]}/>
  )
}
